import { connect } from 'react-redux';

import JSX from '../CustomScript';

const mapStateToProps = (state) => ({
    session: state.session
});

export default connect(mapStateToProps)(JSX);
